<template>
  <div :class="'tw-max-w-[290px]'">
    <div class="tw-font-bold">{{ title }}</div>
    <div>{{ hint }}</div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string;
  hint: string;
}>();
</script>
